import { AccountAccount, AccountUpdateAccount } from '@calm/evexia-web-sdk';
import useAccount, {
    queryKey as accountSyncQueryKey,
} from '@rhg/hooks/use-account';
import createAccountApi from '@rhg/libs/api/create-account-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { queryClient, useMutation } from '@rhg/libs/react-query';
import { getRhgAppHeader } from '@rhg/utils/browser';
import { AxiosError } from 'axios';

export function useUpdateAccount() {
    const rHGApp = getRhgAppHeader();
    const { getAccessTokenSilently } = useAuth();
    const { account } = useAccount();
    const { mutate, mutateAsync, ...otherProps } = useMutation<
        AccountAccount,
        AxiosError,
        AccountUpdateAccount
    >({
        mutationFn: async (payload: AccountUpdateAccount) => {
            const api = createAccountApi(getAccessTokenSilently);
            const response = await api.patchAccountsByUserIdV1({
                userId: account!.userId,
                rHGApp,
                accountUpdateAccount: payload,
            });
            return response.data;
        },
        onSuccess: (account) => {
            queryClient.setQueryData(accountSyncQueryKey, account);
        },
    });
    return {
        updateAccount: mutate,
        updateAccountAsync: mutateAsync,
        ...otherProps,
    };
}
